// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__1ALfX","subheader":"ReorderModal_subheader__2tnwG","listWrap":"ReorderModal_listWrap__1zGs0"};